export default __webpack_public_path__ + "static/media/CardDbPro.a1508211.svg";